
<p-toast></p-toast>
<!-- 
<p *ngIf="this.expenseId>0">ID: {{this.expenseId}}</p> -->

<p-stepper orientation="vertical" #addExpenseStepper [linear]="true">
  <p-stepperPanel header="Expense Details">
    <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
      <expense-add-details #detailsComp *ngIf="activeIndex === 0" [campaignId]="campaignId" [expenseId]="expenseId"
        (nextCallback)="onNextStep()" [confirmAction]="confirmAction.bind(this)"
        (expenseidSelected)="onExpenseSelected($event)" (expensedetailsSelected)="onExpenseDetailsSelected($event)"
        (errorEvent)="showError($event)"></expense-add-details>
    </ng-template>
  </p-stepperPanel>

  <p-stepperPanel header="Line Items & Attachments">
    <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback" let-index="index">
      <expense-add-lineitems #lineItemsComp *ngIf="activeIndex === 1" [campaignId]="campaignId" [expenseId]="expenseId"
        [expenseDetails]="expenseDetails" (prevCallback)="onPrevStep0()" (nextCallback)="onNextStep2()"
        (errorEvent)="showError($event)" [confirmAction]="confirmAction.bind(this)"></expense-add-lineitems>
    </ng-template>
  </p-stepperPanel>

  <p-stepperPanel header="Approvals">
    <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback" let-index="index">
      <expense-add-approvals #approvalsComp *ngIf="activeIndex === 2" [campaignId]="campaignId" [expenseId]="expenseId"
        [expenseDetails]="expenseDetails" (prevCallback)="onPrevStep1()" (nextCallback)="onNextStep3()"
        (errorEvent)="showError($event)" [confirmAction]="confirmAction.bind(this)"></expense-add-approvals>
    </ng-template>
  </p-stepperPanel>

  <p-stepperPanel header="Compliance">
    <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback" let-index="index">
      <expense-add-compliance #complianceComp *ngIf="activeIndex === 3" [campaignId]="campaignId" [expenseId]="expenseId"
        [expenseDetails]="expenseDetails" (prevCallback)="onPrevStep2()" (nextCallback)="onNextStep4()"
        (errorEvent)="showError($event)" [confirmAction]="confirmAction.bind(this)"></expense-add-compliance>
    </ng-template>
  </p-stepperPanel>

  <p-stepperPanel header="Itemization">
    <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">
      <expense-add-itemization #itemizationComp *ngIf="activeIndex === 4" [campaignId]="campaignId" [expenseId]="expenseId"
        [expenseDetails]="expenseDetails" (prevCallback)="onPrevStep3()" (nextCallback)="onNextStep4()"
        (errorEvent)="showError($event)" [confirmAction]="confirmAction.bind(this)"></expense-add-itemization>
    </ng-template>
  </p-stepperPanel>
</p-stepper>

<div class="imported-dialog-footer">
  <!-- (onClick)="onCancel()" -->
  <p-button label="Cancel" type="button" [text]="true" (onClick)="closeExpense()" />
  <p-button type="button" label="Save" (onClick)="saveExpense()" />
</div>

<!-- Confirmation dialog -->
<p-dialog header="Confirm Action" 
  [(visible)]="dialogVisible" 
  [modal]="true" 
  [closable]="false"
  styleClass="d-confirm-dialog">

  <p>{{ dialogMessage }}</p>

  <ng-template pTemplate="footer">
    <button pButton label="No" (click)="onDialogReject()" class="p-button-outlined"></button>
    <button pButton label="Yes" (click)="onDialogAccept()"></button>
  </ng-template>
</p-dialog>